import { useState, useEffect } from "react";
import styles from "./ProductImages.module.css";
import Backdrop from "../../Backdrop/Backdrop";
import { useImageUpload } from "../../ClientLogos/hooks/useImageUpload";

export const ProductImages = ({
  productImages = [],
  mockupImages = [],
  defaultImage = "",
  open = false,
  handleClose = () => {},
  handleUploadNewImage = (type, images) => {},
  handleChangeDefaultImage = (image) => {},
}) => {
  const [selectedTab, setSelectedTab] = useState("product");
  const [selectedImage, setSelectedImage] = useState(defaultImage);
  const { uploadImage } = useImageUpload();

  useEffect(() => {
    setSelectedImage(defaultImage);
  }, [defaultImage, open]);

  useEffect(() => {
    setSelectedImage("");
  }, [selectedTab]);

  if (!open) return null;

  const currentImages =
    selectedTab === "product" ? productImages : mockupImages;
  const imageType = selectedTab === "product" ? "product" : "mockup";

  const handleImageSelect = (image) => {
    setSelectedImage(image);
  };

  const handleSetAsDefault = () => {
    if (selectedImage) {
      handleChangeDefaultImage(selectedImage);
    }
  };

  const handleRemoveImage = () => {
    if (!selectedImage) return;

    const updatedImages =
      imageType === "product"
        ? productImages.filter((img) => img !== selectedImage)
        : mockupImages.filter((img) => img !== selectedImage);

    handleUploadNewImage(imageType, updatedImages);
    setSelectedImage("");
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const uploadedUrl = await uploadImage(file);

      const updatedImages =
        imageType === "product"
          ? [...productImages, uploadedUrl]
          : [...mockupImages, uploadedUrl];

      handleUploadNewImage(imageType, updatedImages);
    } catch (error) {
      console.log(error);
    } finally {
      e.target.value = "";
    }
  };

  return (
    <>
      <Backdrop show={open} switch={handleClose} />
      <div className={styles.dialog}>
        <div className={styles.dialogHeader}>
          <button className={styles.closeButton} onClick={handleClose}>
            ×
          </button>
        </div>

        <div className={styles.tabsContainer}>
          <button
            className={`${styles.tab} ${
              selectedTab === "product" ? styles.activeTab : ""
            }`}
            onClick={() => setSelectedTab("product")}
          >
            Product
          </button>
          <button
            className={`${styles.tab} ${
              selectedTab === "mockup" ? styles.activeTab : ""
            }`}
            onClick={() => setSelectedTab("mockup")}
          >
            Mockups
          </button>
        </div>

        <div className={styles.contentContainer}>
          <div className={styles.imagesGrid}>
            {currentImages.length > 0 ? (
              currentImages.map((image, index) => (
                <div
                  key={index}
                  className={`${styles.imageContainer} ${
                    selectedImage === image ? styles.selectedImage : ""
                  } ${defaultImage === image ? styles.defaultImage : ""}`}
                  onClick={() => handleImageSelect(image)}
                >
                  <img src={image} alt={`${imageType} ${index + 1}`} />
                </div>
              ))
            ) : (
              <>
                <div
                  style={{
                    textAlign: "center",
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#666",
                    width: "100%",
                  }}
                >
                  No Images Uploaded
                </div>
              </>
            )}
          </div>

          <div className={styles.uploadSection}>
            <label htmlFor="image-upload" className={styles.uploadButton}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 5V19M5 12H19"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
              Upload New
            </label>
            <input
              id="image-upload"
              type="file"
              accept="image/*"
              onChange={handleFileUpload}
              style={{ display: "none" }}
            />
            {selectedImage && (
              <>
                <button
                  className={styles.setDefaultButton}
                  onClick={handleSetAsDefault}
                >
                  Set as Default
                </button>
                <button
                  className={styles.removeButton}
                  onClick={handleRemoveImage}
                >
                  Remove Image
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
